export type ArticleSectionType = "briefing" | "portfolio";

export type ArticleLanguage =
    | "ts"
    | "bash"
    | "yaml"
    | "sql"
    | "hcl"
    | "python"
    | "scala"
    | "cpp"
    | "glsl"
    | "json"
    | "text";

/* Paragraph, list and note text accept a small inline markup: [label](url) for
   links and `code` for inline code. See renderInline in view/Article. */
export type ArticleParagraphBlock = {
    type: "paragraph";
    text: string;
};

export type ArticleSubtitleBlock = {
    type: "subtitle";
    text: string;
};

export type ArticleCodeBlock = {
    type: "code";
    language: ArticleLanguage;
    code: string;
    title?: string;
};

export type ArticleListBlock = {
    type: "list";
    items: string[];
};

export type ArticleNoteBlock = {
    type: "note";
    text: string;
};

export type ArticleTerminalLine =
    | { kind: "command"; text: string }
    | { kind: "output"; text: string };

export type ArticleTerminalBlock = {
    type: "terminal";
    title?: string;
    lines: ArticleTerminalLine[];
};

export type ArticleContentBlock =
    | ArticleParagraphBlock
    | ArticleSubtitleBlock
    | ArticleCodeBlock
    | ArticleListBlock
    | ArticleNoteBlock
    | ArticleTerminalBlock;

export type SiteArticle = {
    slug: string;
    section: ArticleSectionType;
    header: string;
    title: string;
    description: string;
    tags: string[];
    url: string;
    content: ArticleContentBlock[];
};

export type ArticleMeta = Omit<SiteArticle, "content">;

export const articleTag = (filename: string) => `/assets/img/${filename}`;
